// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"3279acb8","1195":"3279acb8","2050":"3279acb8","2433":"3279acb8","5370":"3279acb8","6593":"3279acb8","7233":"3279acb8","8925":"3279acb8"}[chunkId] + ".chunk.css";
};